// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteAppNewsModal_deleteButton__23meG"};